import { render, staticRenderFns } from "./TaskGroupPersons.vue?vue&type=template&id=78db670a"
import script from "./TaskGroupPersons.vue?vue&type=script&lang=js"
export * from "./TaskGroupPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports